export default __webpack_public_path__ + "static/media/15.7bce93f8.jpg";